<app-alert *ngIf="helperService.showAlert" [type]=helperService.typeAlert [Message]=helperService.messageAlert></app-alert>
<div class="container-fluid content-container">

  <div class="content-container">
  

    <mat-card>
      <mat-card class="Info-Advisor">
        <mat-card-content>
          <div class="header-containerw">
            
            <div class="header-controlsw">
              <button
                mat-button
                *ngFor="let control of controls"
                (click)="createUser()"
              >
                <i [ngClass]="control.icon"
                  >&nbsp; &nbsp; <strong> {{ "NewUser" | translate }}</strong></i
                >
              </button>
            </div>
          </div>
        </mat-card-content>

        <mat-card class="advisor-grid-container">
          
            <div class="loading-containerAdvisor" *ngIf="!UserLoading">
              <section>
                <div  class="pulsing">
                  <mat-spinner [diameter]="50" ></mat-spinner>
                </div>
                <p class="pulsing">{{"Loading" | translate}}</p>
              </section>
            </div>
        
          <div class="row">
            <div class="col">
              <table class="table table-striped" style="width: 100%">
                <thead>
                  <tr class="advisor-grid-headers">
                    <th scope="col">{{ "Email" | translate }}</th>
                    <th scope="col">{{ "State" | translate }}</th>
                    <th scope="col">
                      {{ "NameUser" | translate }}
                    </th>
                    <th scope="col">{{ "Country" | translate }}</th>
                    <th scope="col">{{ "Role" | translate }}</th>
                    <th scope="col" *ngIf="roleId === 7">Incadea</th>
                    <th scope="col">{{ "Actions" | translate }}</th>
                  </tr>

                  <tr class="advisor-grid-inputs">
                    <th scope="col">
                      <div class="col-lg-12">
                        <mat-form-field>
                          <mat-label>{{ "Filter" | translate }}</mat-label>
                          <input
                            matInput
                            type="text"
                            [(ngModel)]="FilterEmail"
                            (ngModelChange)="resetPagination()"
                          />
                        </mat-form-field>
                      </div>
                    </th>
                    <th scope="col">
                      <div class="col-lg-12">
                        <mat-form-field>
                          <mat-label>{{ "Filter" | translate }}</mat-label>
                          <input
                            oninput="value = value.replace(/[^a-zA-Z0-9áéíóúÁÉÍÓÚüÜ ñÑ.,]/g, '')"
                            matInput
                            type="text"
                            [(ngModel)]="FilterState"
                            (ngModelChange)="resetPagination()"
                          />
                        </mat-form-field>
                      </div>
                    </th>
                   
                    <th
                      scope="col"
                    
                    >
                        <div class="col-lg-12">
                          <mat-form-field>
                            <mat-label>{{ "Filter" | translate }}</mat-label>
                            <input
                            oninput="value = value.replace(/[^a-zA-Z0-9áéíóúÁÉÍÓÚüÜ ñÑ.,]/g, '')"
                              matInput
                              type="text"
                              [(ngModel)]="FilterNameUser"
                              (ngModelChange)="resetPagination()"
                            />
                          </mat-form-field>
                          
                        </div>

                    </th>
                    <th scope="col">
                 
                        <div class="col-lg-12">
                          <mat-form-field>
                            <mat-label>{{ "Filter" | translate }}</mat-label>
                            <input
                            oninput="value = value.replace(/[^a-zA-Z0-9áéíóúÁÉÍÓÚüÜ ñÑ.,]/g, '')"
                              matInput
                              type="text"
                              [(ngModel)]="FilterCountry"
                              (ngModelChange)="resetPagination()"
                            />
                          </mat-form-field>
                        </div>

                    </th>
                    <th scope="col">
                      <div class="col-lg-12">
                        <mat-form-field>
                          <mat-label>{{ "Filter" | translate }}</mat-label>
                          <input
                          oninput="value = value.replace(/[^a-zA-Z0-9áéíóúÁÉÍÓÚüÜ ñÑ.,]/g, '')"
                            matInput
                            type="text"
                            [(ngModel)]="FilterRol"
                            (ngModelChange)="resetPagination()"
                          />
                        </mat-form-field>
                      </div>
                    </th>
                  </tr>
                </thead>

                <tbody *ngIf="UserLoading" >
                  <tr
                  
                    *ngFor="
                      let UsersData of UsersData  | filterUserManagements: FilterEmail:FilterState: FilterNameUser : FilterCountry : FilterRol
                      | slice : desde : hasta;
                      let index = index
                    "
                  >
                    <td style="width: 13%; font-size: 16px; text-align: center">
                      {{ UsersData.email }}
                    </td>
                    <td style="width: 15%; font-size: 16px; text-align: center">
                      <mat-label
                        class="switch-right-label"
                      >{{UsersData.isActive
                        ? ('Active' | translate | capitalize)
                        : ('Inactive' | translate | capitalize)}}
                        <mat-slide-toggle
                          size="small"
                          class="custom-switch"
                          [(ngModel)]="UsersData.isActive"
                          (click)="ChangeState(UsersData)"
                        ></mat-slide-toggle>
                      </mat-label>
                    </td>
                    <td
                    style="width: 13%; font-size: 16px; text-align: center"
                    
                    >
                  {{UsersData.userName}}
                  </td>
                  <td style="width: 13%; font-size: 16px; text-align: center">
                    {{ UsersData.countryName }}
                  </td>
                  <td style="width: 13%; font-size: 16px; text-align: center">
                    {{ UsersData.roleName }}
                  </td>
                  <td style="width: 13%; font-size: 16px; text-align: center" *ngIf="roleId === 7">
                    <mat-label
                    class="switch-right-label"
                  >{{UsersData.isIncadea === 0 ? 'No': ("Yes" | translate | capitalize)}}
                    
                  </mat-label>
                  </td>
                    <td style="width: 16%">
                      <div class="grid-controls">
                        <button class="action-btnUsers col-lg-3">
                          <i
                            class= "material-icons-outlined"
                            (click)="EditInfoUser(UsersData)"
                            matTooltip="{{ 'EditInformation' | translate }}"
                          >
                            create
                          </i>
                        </button>

                       

                        <button class="action-btnUsers col-lg-3">
                          <i
                            class="material-icons-outlined"
                            [id]="'trash3-' + index"
                            (click)="DeleteUser(UsersData)"
                            matTooltip="{{ 'DeleteUser' | translate }}"
                          >
                            delete
                          </i>
                        </button>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <div class="row advisor-grid-footer">
            <mat-divider></mat-divider>
          </div>
          <div class="row grid-pagination-container" *ngIf="UserLoading" >
            <mat-paginator
              [length]="(UsersData  | filterUserManagements: FilterEmail:FilterState: FilterNameUser : FilterCountry : FilterRol)?.length"
              [pageSize]="pagesize"
              [pageSizeOptions]="[4, 8, 16, 32]"
              aria-label="Select page"
              (page)="changePage($event)"
              showFirstLastButtons
            >
            </mat-paginator>
          </div>
        </mat-card>
      </mat-card>
    </mat-card>
  </div>
</div>
